var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Request Profile Removal ")]),
          _c(
            "gg-card-text",
            [
              _c("h4", [_vm._v("Right To Erasure")]),
              _c("p", [
                _vm._v(
                  "Request your profile be permanently removed from our systems."
                )
              ]),
              _c(
                "gg-btn",
                {
                  staticClass: "ml-0",
                  attrs: {
                    secondary: "",
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.requestAccountClosure
                  }
                },
                [
                  _vm._v(" Request Account Closure "),
                  _c(
                    "span",
                    {
                      staticClass: "visually-hidden text-lowercase"
                    },
                    [_vm._v("button")]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.removalPossible === false
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.modal,
              "max-width": "350"
            },
            on: {
              close: _vm.cancel
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function fn() {
                    return [_vm._v(" Profile Removal Failed ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _vm.reasons.length === 0
                        ? [
                            _vm._v(
                              " Unfortunately your account is not eligible for profile removal. You may "
                            ),
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "support_ticketnew",
                                    query: {
                                      d: "Support",
                                      s: "other",
                                      sbj: "Profile Removal Request"
                                    }
                                  }
                                }
                              },
                              [_vm._v("open a ticket")]
                            ),
                            _vm._v(" for assistance. ")
                          ]
                        : [
                            _vm._v(
                              " Your profile is not eligible for removal because of the following reasons: "
                            ),
                            _vm._l(_vm.reasons, function(reason, i) {
                              return _c(
                                "p",
                                {
                                  key: "".concat(i, "-rsn"),
                                  staticClass: "mb-0"
                                },
                                [_vm._v(" " + _vm._s(reason) + " ")]
                              )
                            }),
                            _c("br"),
                            _c("p", [
                              _vm._v("You may "),
                              _c(
                                "b",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "support_ticketnew",
                                          query: {
                                            d: "Support",
                                            s: "other",
                                            sbj: "Profile Removal Request"
                                          }
                                        }
                                      }
                                    },
                                    [_vm._v("open a ticket")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" for assistance.")
                            ])
                          ]
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.cancel
                          }
                        },
                        [_vm._v(" Close ")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2794243638
            )
          })
        : _vm.removalPossible === true
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.modal,
              "max-width": "550"
            },
            on: {
              close: _vm.cancel
            },
            scopedSlots: _vm._u([
              {
                key: "toolbar",
                fn: function fn() {
                  return [_vm._v(" Profile Removal Confirmation ")]
                },
                proxy: true
              },
              {
                key: "body",
                fn: function fn() {
                  return [
                    _vm._v(
                      " Your account is eligible for profile removal. Would you like to proceed? "
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "actions",
                fn: function fn() {
                  return [
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          secondary: ""
                        },
                        on: {
                          click: _vm.cancel
                        }
                      },
                      [
                        _vm._v(" No "),
                        _c(
                          "span",
                          {
                            staticClass: "visually-hidden text-lowercase"
                          },
                          [_vm._v(" button ")]
                        )
                      ]
                    ),
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          loading: _vm.loadingRemove,
                          primary: ""
                        },
                        on: {
                          click: _vm.removeAccount
                        }
                      },
                      [
                        _vm._v(" Yes "),
                        _c(
                          "span",
                          {
                            staticClass: "visually-hidden text-lowercase"
                          },
                          [_vm._v(" button ")]
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }